import getApiClient from '@/plugins/api-client'

export default {
  auth () {
    const api = getApiClient(this.$store)

    this.error = ''

    api.post('/auth', {
      username: `a:${this.username}`,
      password: this.password,
    })
      .then(result => {
        this.$store.commit('app/setSessionToken', result.data.token)
        this.$store.commit('app/setSessionRefreshToken', result.data.refresh_token)
        this.$store.commit('app/setUserIri', result.data.user_iri)
        this.$store.commit('app/setRoles', result.data.roles)
        this.$router.push({
          name: 'Dashboard',
        })
      })
      .catch(error => {
        this.error = error?.response?.data?.message ?? 'Unexpected error'
      })
  },
}
